import { RelationalOperatorKey } from '../../apollo/graphqlSchema';

export const COHORT_PERCENTILE_FILTER_PLACEHOLDER = '%ile';

interface IGetCohortPercentileFilterLabelArgs {
  operatorKey: RelationalOperatorKey;
  operatorName: string;
  values: number[];
}

export const getCohortPercentileFilterLabel = ({
  operatorKey,
  operatorName,
  values,
}: IGetCohortPercentileFilterLabelArgs) => {
  if (operatorKey === RelationalOperatorKey.Between) {
    return `${operatorName} ${values[0]} ~ ${values[1]} ${COHORT_PERCENTILE_FILTER_PLACEHOLDER}`;
  }

  return `${operatorName} ${values[0]} ${COHORT_PERCENTILE_FILTER_PLACEHOLDER}`;
};
